import React from 'react';
import { Button } from "tabler-react";
import './style.css';

const PhotoModal = ({ photo, close }) => {
    return (
        <div id="photoModal">
            <Button size="sm" icon="x" className="closeModal" onClick={close} />
            <img src={photo} alt="Zoom" />
        </div>
    )
}

export default PhotoModal;